module.exports = __webpack_public_path__ + "static/media/camera.379c0978.svg";